// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"nW","cross":"nX","iconSVGWrapper":"nY","iconSVG":"nZ","iconSVGDark":"n0"};